import { render } from "./EditionBilling.vue?vue&type=template&id=23158ec1&scoped=true&ts=true"
import script from "./EditionBilling.vue?vue&type=script&lang=ts"
export * from "./EditionBilling.vue?vue&type=script&lang=ts"

import "./EditionBilling.vue?vue&type=style&index=0&id=23158ec1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23158ec1"]])

export default __exports__